var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeAttached(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 47.5,
    height: 47.5,
    rx: 23.75,
    stroke: "#323F4B",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13096_181610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3389 30.0612L23.0776 31.3672C20.8216 32.6699 17.9356 31.8965 16.6323 29.6392C15.3303 27.3825 16.1036 24.4972 18.3596 23.1945L20.6216 21.8885L21.6183 23.6145L19.3563 24.9212C18.0563 25.6712 17.6083 27.3419 18.3596 28.6419C19.1103 29.9439 20.7803 30.3919 22.0809 29.6385L24.3423 28.3345L25.3389 30.0612ZM23.1963 18.3592L21.8903 20.6205L23.6163 21.6185L24.9223 19.3565C25.6729 18.0565 27.3429 17.6085 28.6429 18.3599C29.9443 19.1112 30.3923 20.7792 29.6423 22.0812L28.3356 24.3425L30.0616 25.3385L31.3683 23.0779C32.6696 20.8199 31.8963 17.9352 29.6416 16.6332C27.3836 15.3299 24.4976 16.1032 23.1963 18.3592ZM28.1283 31.8372L26.9789 31.9999L26.6303 29.5412L27.7783 29.3792L28.1283 31.8372ZM32.0003 26.9812L31.8343 28.1305L29.3756 27.7792L29.5403 26.6312L32.0003 26.9812ZM28.1783 28.9899L28.9976 28.1699L30.7563 29.9272L29.9356 30.7472L28.1783 28.9899Z",
    fill: "#7B8794"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13096_181610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeAttached);
export default __webpack_public_path__ + "static/media/de-attached.f2621e1e50a52cadf229afbcb90e7979.svg";
export { ForwardRef as ReactComponent };